module.exports = __webpack_public_path__ + "img/限时特惠.06cb8f40.svg";